import React, { useState } from 'react';
import styled from 'styled-components';

import { Spacing } from '../../../../theme';
import { CustomFormContainer } from '../../../mama-form';
import { Faq } from '../faq';
import { Help } from '../help';
import { MarqueeComponent } from '../marquee';
import { Content } from './frame/content';
import { Hero } from './frame/hero';
import { Legal } from './legal';

export const Component: React.FC<{}> = ({ }) => {
  const [isOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setModalOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <Container>
        <Hero />
      </Container>
      <MarqueeComponent color="yellow" />
      <Container>
        <Content />
        <FormContainer>
          <CustomFormContainer />
        </FormContainer>
        {/* <Registration openModal={openModal} /> */}
        {/* <Modal isOpen={isOpen} closeModal={closeModal} /> */}
      </Container>
      <MarqueeComponent color="pink" rotate={3} />
      <Container>
        <Faq />
        <Help />
      </Container>
      <Legal />
    </>
  );
};

const FormContainer = styled.div`
  padding: 60px 0px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 ${Spacing(4)};
  padding-top: 30px;
  max-width: 1230px;
  width: min(100vw, 1230px);

`;

